import styles from './StarRating.module.scss'
import { FC, memo, useMemo } from 'react'
// import YellowStar from '../../assets/icons/YellowStar.svg'
import GrayYellowStar from '../../assets/icons/GrayYellowStar.svg'
import GrayStar from '../../assets/icons/GrayStar.svg'

const MAX_RATING = 5
const MIN_RATING = 0

const starSize = {
  s: 's',
  m: 'm',
} as const

type StarSize = ObjectValues<typeof starSize>

interface StarRatingProps {
  rating?: number
  starSize?: StarSize
}

const StarRating: FC<StarRatingProps> = memo((props) => {
  const { rating = 0, starSize = 's' } = props
  const starRating = useMemo(() => {
    if (
      typeof rating === 'number' &&
      rating >= MIN_RATING &&
      rating <= MAX_RATING
    ) {
      const starClass =
        starSize === 's'
          ? [styles.StarIcon, styles.SizeS].join(' ')
          : starSize === 'm'
          ? [styles.StarIcon, styles.SizeM].join(' ')
          : [styles.StarIcon, styles.SizeS].join(' ')
      const array = Array.from({ length: MAX_RATING }, (_, i) => i)

      return array.map((item) =>
        item >= rating ? (
          <img
            className={starClass}
            src={GrayStar}
            alt="star icon"
            width={starSize}
            key={item}
          />
        ) : item === Math.floor(rating) ? (
          <img
            className={starClass}
            src={GrayYellowStar}
            alt="star icon"
            width={starSize}
            key={item}
          />
        ) : (
          <img
            className={starClass}
            src={GrayYellowStar}
            alt="star icon"
            width={starSize}
            key={item}
          />
        )
      )
    }
    return null
  }, [rating, starSize])

  return <div className={styles.StarRating}>{starRating}</div>
})

export default StarRating
